import React, { useContext, useReducer, useState } from "react";
import { toast } from "sonner";
import { Navigate } from "react-router-dom";
import Axios from "axios";
import { Data } from "../../../Data";
import { getError } from "../../../utils/utils";
import { Helmet } from "react-helmet-async";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { Button } from "../../../components/ui/button";
import { Input } from "../../../components/ui/input";
import { Label } from "../../../components/ui/label";
import { Spinner } from "../../../components/ui/spinner";
import LegalInfo from "../../components/LegalInfo";

const reducer = (state, action) => {
    switch (action.type) {
        case "FETCH_REQUEST":
            return { ...state, loading: true };
        case "FETCH_SUCCESS":
            return { ...state, authData: action.payload, loading: false };
        case "FETCH_FAIL":
            return { ...state, loading: false };
        default:
            return state;
    }
};

export default function AdminLogin() {
    const [birthNo, setBirthNo] = useState("");
    const [refNo, setRefNo] = useState("");
    const [password, setPassword] = useState("");

    const { state, dispatch: ctxDispatch } = useContext(Data);
    const { userInfo } = state;
    const [{ loading }, dispatch] = useReducer(reducer, {
        authData: [],
        loading: false,
    });

    const authLoginHandler = async (e) => {
        e.preventDefault();
        dispatch({ type: "FETCH_REQUEST" });
        const isDev = process.env.REACT_APP_ENV === "development";
        if ((birthNo.length < 10 && refNo.length < 2) || (!isDev && password.length < 6)) {
            dispatch({ type: "FETCH_FAIL" });
            return toast.error("Všechna pole musí být vyplněna!");
        }
        try {
            const { data } = await Axios.post("/api/auth/auth-admin", {
                birthNo,
                refNo,
                password,
            });
            ctxDispatch({ type: "USER_SIGNIN", payload: data });
            localStorage.setItem("userInfo", JSON.stringify(data));
            dispatch({ type: "FETCH_SUCCESS" });
            toast.success("Úspěšně přihlášen!");
        } catch (err) {
            dispatch({ type: "FETCH_FAIL" });
            toast.error(getError(err));
        }
    };

    if (userInfo) return <Navigate to="/" />;

    return (
        <>
            <Helmet>
                <title>Portál pro dlužníky | De Vries Group, a.s.</title>
            </Helmet>
            <main className="bg-gray-50">
                <div className="min-h-screen flex items-center justify-center py-12 px-4">
                    <div className="w-full max-w-md">
                        <div className="flex justify-center mb-6">
                            <img src="/logo.png" alt="De Vries Group" className="h-10 object-contain" />
                        </div>
                        <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-8">
                            <h1 className="text-3xl font-semibold text-center mb-2">
                                Admin přihlášení
                            </h1>
                            <p className="text-center text-sm text-gray-600 mb-6">
                                Přihlaste se jako administrátor. Prosím pokračujte Jen pokud jste administrátor. Neoprávněný přístup bude hlášen a řešen.
                            </p>
                            <form onSubmit={authLoginHandler} className="space-y-4">
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 relative">
                                    <div>
                                        <Label htmlFor="birthno" className="mb-1 block">
                                            Rodné číslo
                                        </Label>
                                        <Input
                                            id="birthno"
                                            type="text"
                                            minLength={10}
                                            maxLength={10}
                                            value={birthNo}
                                            disabled={refNo.length > 0}
                                            onChange={(e) => setBirthNo(e.target.value)}
                                            placeholder=" "
                                        />
                                    </div>

                                    <span className="hidden sm:flex absolute left-1/2 top-1/2 -translate-x-1/2 translate-y-2 text-xs text-gray-400 items-center gap-1 pointer-events-none z-10">
                                        <FontAwesomeIcon icon={faArrowLeft} />
                                        nebo
                                        <FontAwesomeIcon icon={faArrowRight} />
                                    </span>

                                    <div>
                                        <Label htmlFor="refno" className="mb-1 block">
                                            Referenční číslo
                                        </Label>
                                        <Input
                                            id="refno"
                                            type="text"
                                            minLength={2}
                                            maxLength={30}
                                            value={refNo}
                                            disabled={birthNo.length > 0}
                                            onChange={(e) => setRefNo(e.target.value)}
                                            placeholder=" "
                                        />
                                    </div>
                                </div>

                                {process.env.REACT_APP_ENV !== "development" && (
                                <div>
                                    <Label htmlFor="password" className="mb-1 block">
                                        Heslo
                                    </Label>
                                    <Input
                                        id="password"
                                        type="password"
                                        minLength={6}
                                        maxLength={30}
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        placeholder=" "
                                    />
                                </div>
                                )}

                                <div className="flex items-center gap-3 pt-2">
                                    <Button type="submit" className="w-full">
                                        Přihlásit
                                    </Button>
                                    {loading && <Spinner />}
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <LegalInfo variant="footer" />
            </main>
        </>
    );
}
